import { Stack, Autocomplete, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { urlGetContactData } from '../../../helpers/index';

export const DataForm = ({ formValues, data, handleInputChange }) => {

    const { client, status, contact, characteristics, date, dateCall, iva, paymentMethod, address, paymentMethodRent, paymentMethodOptions } = formValues;
    const [hasClient, setHasClient] = useState(false);
    const [contactListName, setContactListName] = useState([]);
    const [contactList, setContactList] = useState([]);

    useEffect(() => {
        if (data?.filter((c) => c.name === client)?.length > 0) {
            handleInputChange({ target: { 'name': 'contact', 'value': '' } })
            const token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken');
            fetch(urlGetContactData + '?name=' + client, { headers: { 'Authorization': `Bearer ${token}` } })
                .then((r) => r.json())
                .then((d) => {
                    setHasClient(d.data.length > 0)
                    setContactListName(JSON.parse(d.data[0].contacts).map(c => c.contactName))
                    setContactList(JSON.parse(d.data[0].contacts))
                })
        } else {
            setHasClient(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, client])

    const clientContact = client.name ? JSON.parse(client?.contacts)[0] : undefined;

    return (
        <Stack flexDirection='row' spacing={1} flexWrap='wrap' justifyContent='space-around' gap={5}>
            <Stack flexDirection='row' width='90%' justifyContent='space-around' flexWrap='wrap' >
                {client.name
                    ? <Typography><b>Cliente:</b> {client.name}</Typography>
                    : <Autocomplete
                        disablePortal
                        noOptionsText='Elige una opción correcta'
                        options={data?.map((c) => c.name) || []}
                        sx={{ width: 400 }}
                        size='small'
                        value={client || null}
                        onChange={(event, newValue) => {
                            handleInputChange({ target: { name: 'client', value: newValue || '' } });
                        }}
                        renderInput={(params) => <TextField {...params} label="Cliente" required />}
                    />}
                {client.name
                    ? <Typography><b>Persona de contacto:</b> {contact}</Typography>
                    : <Autocomplete
                        disabled={!hasClient}
                        disablePortal
                        noOptionsText='Elige una opción correcta'
                        options={[...contactListName, ''] || []}
                        sx={{ width: 400 }}
                        size='small'
                        value={contact || null}
                        onChange={(event, newValue) => {
                            handleInputChange({ target: { name: 'contact', value: newValue || '' } });
                        }}
                        renderInput={(params) => <TextField {...params} label="Persona de contacto" required />}
                    />
                }

            </Stack>
            {client.name
                ? <Stack flexDirection='row' width='80%' justifyContent='space-between' flexWrap='wrap' >
                    <Typography><b>Teléfono de contacto:</b> {clientContact.contactTel}</Typography>
                    <Typography><b>Email de contacto:</b> {clientContact.contactEmail}</Typography>
                    <Typography><b>Cargo:</b> {clientContact.jobPosition}</Typography>
                </Stack>
                : <Stack flexDirection='row' width='80%' justifyContent='space-between' flexWrap='wrap' >
                    <Typography><b>Teléfono de contacto:</b> {contactList.filter(e => e.contactName === contact)[0]?.contactTel || '----'}</Typography>
                    <Typography><b>Email de contacto:</b> {contactList.filter(e => e.contactName === contact)[0]?.contactEmail || '----'}</Typography>
                    <Typography><b>Cargo:</b> {contactList.filter(e => e.contactName === contact)[0]?.jobPosition || '----'}</Typography>
                </Stack>
            }

            <Stack flexDirection='row' width='80%' justifyContent='space-between' flexWrap='wrap' >
                <TextField
                    sx={{ width: '100%' }}
                    label="Dirección de la obra"
                    type="search"
                    variant="filled"
                    size="small"
                    name="address"
                    value={address}
                    onChange={handleInputChange}
                    required
                />
            </Stack>
            <Stack flexDirection='row' width='80%' justifyContent='space-between'>
                <Autocomplete
                    disablePortal
                    options={['Provisional', 'Definitivo', 'Aceptado', '']}
                    sx={{ width: '48%' }}
                    noOptionsText='Elige una opción correcta'
                    size='small'
                    value={['Provisional', 'Aceptado', 'Definitivo', ''].includes(status) ? status : null}
                    onChange={(event, newValue) => {
                        handleInputChange({ target: { name: 'status', value: newValue || '' } });
                    }}
                    renderInput={(params) => <TextField {...params} label="Estado" required />}
                />
                <Autocomplete
                    options={['10%', '21%', '']}
                    sx={{ width: '48%' }}
                    size='small'
                    noOptionsText='Elige una opción correcta'
                    value={['10%', '21%'].includes(iva) ? iva : null}
                    onChange={(event, newValue) => {
                        handleInputChange({ target: { name: 'iva', value: newValue || '' } });
                    }}
                    renderInput={(params) => <TextField {...params} label="IVA" required />}
                />
            </Stack>
            <Stack flexDirection='row' width='80%' justifyContent='space-between'>
                <TextField
                    sx={{ width: '30%' }}
                    label="Forma de pago montaje y desmonatje"
                    type="search"
                    variant="outlined"
                    name='paymentMethod'
                    size='small'
                    value={paymentMethod}
                    onChange={handleInputChange}
                    required
                />
                <TextField
                    sx={{ width: '30%' }}
                    label="Forma de pago alquileres"
                    type="search"
                    variant="outlined"
                    name='paymentMethodRent'
                    size='small'
                    value={paymentMethodRent}
                    onChange={handleInputChange}
                    required
                />
                <TextField
                    sx={{ width: '30%' }}
                    label="Forma de pago opcional"
                    type="search"
                    variant="outlined"
                    name='paymentMethodOptions'
                    size='small'
                    value={paymentMethodOptions}
                    onChange={handleInputChange}
                />
            </Stack>
            <Stack flexDirection='row' width='80%' justifyContent='space-around'>
                <TextField
                    label="Caracteristicas"
                    type="search"
                    variant="filled"
                    fullWidth
                    name='characteristics'
                    value={characteristics}
                    onChange={handleInputChange}
                    multiline
                    required
                />
            </Stack>
            <Stack width='100%' alignItems='center'>
                <Stack flexDirection='row' width='90%' justifyContent='space-around' alignItems='flex-end' >
                    <label >Fecha presupuesto:</label >
                    <TextField
                        sx={{ width: '160px', height: '30px' }}
                        type="date"
                        variant="standard"
                        name='date'
                        value={date}
                        onChange={handleInputChange}
                        required
                    />
                    <label >Llamar el:</label >
                    <TextField
                        sx={{ width: '160px' }}
                        type="date"
                        variant="standard"
                        name='dateCall'
                        value={dateCall}
                        onChange={handleInputChange}
                        required
                    />
                </Stack>
            </Stack>
        </Stack>
    )
}
